module.exports = new __parcel__URL__("donut.e4649522.svg").toString();